
// react select style
export const selectStyle = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      //console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isFocused ? "var(--orange)" : null,
        color: "#302f2f",
      };
    },
    control: (base, state) => ({
      ...base,
      // match with the menu
      borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "var(--darkGray)" : "var(--orange)",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        borderColor: state.isFocused ? "var(--darkGray)" : "var(--orange)",
      }
    }),
  }
  